import store from './store';
import CONSTANTS from './constants';

const requestInterceptor = request => { return request; };

const responseInterceptor = response => { return response; };

const requestErrorInterceptor = error => { return Promise.reject(error); };

const responseErrorInterceptor = error => {
	switch (error.response.status) {
		case 400:
			error.response.data.errors.map(message => {
				Vue.toasted.error(`&nbsp;${message}`, {});
			});
			break;
		case 422:
			store.commit(`formErrors/${CONSTANTS.MUTATIONS.PUSH_ERRORS}`, error.response.data.errors);
			break;
		default:
			break;
	}
	return Promise.reject(error);
};

window.axios.interceptors.request.use(requestInterceptor, requestErrorInterceptor);
window.axios.interceptors.response.use(responseInterceptor, responseErrorInterceptor);



// WEBPACK FOOTER //
// ./resources/js/axios-interceptor.js